export default __webpack_public_path__ + "media/verification/title_locale_de-796802c7.png";